export type YattaLangId = 'de' | 'en';
